/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//住所登録フォームの国項目非表示 (main-customers-addresses.liquid)
document.addEventListener("DOMContentLoaded", function() {
    HTMLElement.prototype.trigger = function(eStr) {
      var e = document.createEvent("HTMLEvents");
      e.initEvent(eStr, true, true );
      this.dispatchEvent(e);
    }
    
    const specifyJapan = (domElement) => {
     selector_options = domElement.options;
      for(let i = 0; i < selector_options.length; i++ ){
          if(selector_options[i].value === 'Japan'){
              selector_options[i].selected = true;
              break;
          }
      }
      domElement.trigger("change");
    }
    
    //新規登録
    const new_address_country = document.getElementById('custom--address-new-country');
    if(new_address_country){specifyJapan(new_address_country);}
    //更新
    const edit_address_country = document.querySelectorAll('.custom--address-edit-country');
    if(edit_address_country){
      edit_address_country.forEach(element => specifyJapan(element));
      //初期値処理
      const edit_address_province = document.querySelectorAll('select[name="address[province]"]');
      edit_address_province.forEach(element => {
        if(element.dataset.default){
          selector_options = element.options;
          for(let i = 0; i < selector_options.length; i++ ){
              if(selector_options[i].innerText === element.dataset.default){
                  selector_options[i].selected = true;
                  break;
              }
          }
          element.trigger("change");
        }
      });
    }
})
